import { __assign } from "tslib";
import React, { useEffect, useRef } from 'react';
import { SearchResult } from './search-result';
import { getSolutionsBaseBySearchQuery } from '../../api/api';
import { biLogger } from '../../bi';
import { config } from '../../config';
import { WithFetcher, } from '../../component-decorators/with-fetcher';
import { SearchResultEmptyStateFetcher } from './search-result-empty-state';
import { CenteredLoader } from '../centered-loader';
import { isBrowser } from '../../common/utils';
import { Origin, Path } from '../../enums/marketplace-enums';
import { SearchResultsSEO } from './search-result-seo';
import { useConfigContext } from '../../config-context';
import { useMarketplaceStore } from '../../component-decorators/with-marketplace-store';
import { getReferralInfo, getWidgetReferral } from '../../common/bi-events';
import { AppMarketPage } from '../../types/common/marketplace';
import { HeaderHolidaySaleExport } from '@wix/app-market-collection-widget';
export var SearchResultContainer = function (_a) {
    var fetchData = _a.fetchData, reFetch = _a.reFetch, locale = _a.locale, query = _a.query, isMobile = _a.isMobile, showHolidaySale = _a.showHolidaySale;
    var didComponentMountRef = useRef(false);
    var marketplaceStore = useMarketplaceStore();
    var suggestedApps = fetchData.suggestions;
    var foundResultsForSearchTerm = query && suggestedApps.length > 0;
    var searchResultProps = {
        searchResultHeaderProps: {
            query: query,
            isResult: true,
            numOfResults: suggestedApps.length,
        },
        solutionGridWrapperProps: {
            solutions: suggestedApps.map(function (solution, appIndex) {
                return __assign({ appIndex: appIndex }, solution);
            }),
            isCompany: true,
        },
    };
    var sendPageViewBi = function () {
        var biEventParams = {
            market: config.originForBI,
            tag_name: query,
            tag_type: AppMarketPage.SEARCH_RESULT,
            navigation_source: marketplaceStore.route.referral,
            referral_info: getReferralInfo(marketplaceStore.route && marketplaceStore.route.referral, marketplaceStore.prevRoute),
            search_term: query,
            widget_referral: getWidgetReferral(),
        };
        biLogger.appMarketPageView(biEventParams);
    };
    var sendSearchResultPageBi = function () {
        var biEventParams = {
            first_result_app_id: suggestedApps.length > 0 ? suggestedApps[0].id : null,
            market: config.originForBI,
            num_results: suggestedApps.length,
            search_term: query,
        };
        biLogger.searchSearchResults(biEventParams);
    };
    useEffect(function () {
        if (didComponentMountRef.current) {
            reFetch(function () { return getSolutionsBaseBySearchQuery(query, locale); });
        }
        else {
            didComponentMountRef.current = true;
        }
    }, [query, locale]);
    useEffect(function () {
        sendPageViewBi();
        sendSearchResultPageBi();
    }, [fetchData]);
    // tslint:disable-next-line: react-hooks-nesting
    var _b = React.useState(false), showHolidaySaleBanner = _b[0], setShowHolidaySaleBanner = _b[1];
    React.useEffect(function () {
        var showBanner = showHolidaySale && !isMobile;
        setShowHolidaySaleBanner(showBanner);
    });
    isBrowser() && window.scrollTo(0, 0);
    console.log("marketplace-component/src/components/search-result/search-result-container.tsx file - line 98 - " + Date.now());
    return (React.createElement("div", null,
        showHolidaySaleBanner && (React.createElement(HeaderHolidaySaleExport, { locale: locale, skin: 'all-pages', onClick: function () {
                return config.goto({
                    path: Path.CATEGORY,
                    slug: 'pre-holiday-sale',
                    referral: "sale-banner-" + marketplaceStore.route.path,
                });
            }, origin: config.origin, msId: marketplaceStore.metaSiteId, referral: 'search' })),
        foundResultsForSearchTerm ? (React.createElement(SearchResult, __assign({}, searchResultProps))) : (React.createElement(SearchResultEmptyStateFetcher, { query: query }))));
};
export var SearchResultFetcher = function (_a) {
    var query = _a.query, showHolidaySale = _a.showHolidaySale;
    // tslint:disable-next-line: react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, isMobile = _b.isMobile, rpcClient = _b.rpcClient;
    console.log("marketplace-component/src/components/search-result/search-result-container.tsx file - line 116 - " + Date.now());
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: function () { return getSolutionsBaseBySearchQuery(query, locale, 36, 0, rpcClient); }, fetchMemoizationId: "search-result-" + query }, function (_a) {
        var fetchData = _a.fetchData, reFetch = _a.reFetch;
        return (React.createElement(React.Fragment, null,
            config.origin === Origin.STANDALONE && React.createElement(SearchResultsSEO, null),
            React.createElement(SearchResultContainer, { fetchData: fetchData, reFetch: reFetch, locale: locale, isMobile: isMobile, query: query, showHolidaySale: showHolidaySale })));
    }));
};
//# sourceMappingURL=search-result-container.js.map